import { init } from "../init";
import { SearchResultsPage } from "../pages/search/search";
init(SearchResultsPage);
